// ── Invite code (set REACT_APP_INVITE_CODE in .env.local) ────────
// Note: this lives in the client bundle and is visible to anyone who
// inspects the JS. It's a low-friction gate, not real access control.
// For real access control, enforce on the Supabase side (RLS + a
// server-side check inside the signup edge function).
export const INVITE_CODE = process.env.REACT_APP_INVITE_CODE || "";

// ── Skip reasons ─────────────────────────────────────────────────
// ONE list, imported everywhere a visit can be skipped (RouteSkipModal, SkipVisitModal,
// JobDetailModal). jobs.skipped_reason stores the CODE; the label is display-only.
// The DB only accepts these nine codes (sql/093 jobs_skipped_reason_chk) and maps any
// legacy/free text to one of them, keeping the original text in jobs.skip_note.
// Keep in sync with the field app (VisitDetailView.swift) and api-v1/README.md.
export const SKIP_REASON_OPTIONS = [
  { code: "unsafe_dog",         label: "Unsafe Dog" },
  { code: "locked_gate",        label: "Locked Gate" },
  { code: "bad_weather",        label: "Bad Weather" },
  { code: "yard_condition",     label: "Yard Condition" },
  { code: "cant_find_location", label: "Can't Find Location" },
  { code: "client_request",     label: "Client Request" },
  { code: "non_payment",        label: "Non-Payment" },   // account unpaid — never issue a skip credit for this
  { code: "holiday",            label: "Holiday" },
  { code: "other",              label: "Other" },
];
export const SKIP_REASONS = SKIP_REASON_OPTIONS.map(o => o.code);
const SKIP_LABEL = Object.fromEntries(SKIP_REASON_OPTIONS.map(o => [o.code, o.label]));
// Label for a stored code; falls back to the raw text (pre-093 rows in an old cache, etc).
export const skipReasonLabel = (code) => (code ? SKIP_LABEL[code] || code : "");
export const SKIP_NOTE_MAX = 500;

// Reasons for crediting a visit that DID happen (quality complaint, etc).
// Distinct from a skip: the visit still counts as completed.
export const CREDIT_REASONS = [
  "Client complaint",
  "Quality issue / missed spots",
  "Damaged property",
  "Late arrival",
  "Goodwill / retention",
  "Other",
];
